import { render } from "./industry-ranking.vue?vue&type=template&id=7bb8e5ab"
import script from "./industry-ranking.vue?vue&type=script&lang=ts"
export * from "./industry-ranking.vue?vue&type=script&lang=ts"
script.render = render

export default script